import { useTranslation } from "react-i18next";
import { useGetMyDealersLazyQuery } from "~/schemas/generated/graphql";
import { useEffect } from "react";
import { debounce, get } from "lodash";
import { language } from "~/libs/getData";
import { useGetLocationData } from "~/hooks/locationData";
import { usePermissions } from "~/shared/context/PermissionContext";

export const onScrollBottomDealersFO = () => {
  const { t } = useTranslation();
  const isEn = language === "en";
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const { sortField } = useGetLocationData();

  const [GetDealersForSelectQuery, { data, loading, fetchMore }] =
    useGetMyDealersLazyQuery({
      variables: {
        FederalArea: sortField ? (isEn ? undefined : sortField) : undefined,
        FederalAreaEn: sortField ? (isEn ? sortField : undefined) : undefined,
        count: 10,
        page: 0,
      },
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
    });

  useEffect(() => {
    GetDealersForSelectQuery();
  }, []);

  const dealersForSelect = [
    ...get(data, "DealerGetter.getMyDealers.items", []).map(
      ({ id, DealerName, DealerNameEn }) => {
        return {
          value: id,
          label: isEn ? DealerNameEn : DealerName,
        };
      }
    ),
  ];

  const introspectionHandler = () => {
    if (dealersForSelect.length < 10) {
      return;
    }
    const page = Math.ceil(dealersForSelect.length / 10);
    fetchMore({
      variables: {
        page,
      },
      updateQuery: ({ DealerGetter }, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return { DealerGetter };
        }

        return {
          DealerGetter: {
            ...DealerGetter,
            getMyDealers: {
              ...DealerGetter.getMyDealers,
              items: [
                ...DealerGetter.getMyDealers.items,
                ...get(fetchMoreResult, "DealerGetter.getMyDealers.items", []),
              ],
            },
          },
        };
      },
    });
  };

  const searchDealer = debounce((searchText: string) => {
    GetDealersForSelectQuery({
      variables: {
        page: 0,
        partName: searchText,
      },
    });
  });

  return {
    dealersForSelect,
    introspectionHandler,
    searchDealer,
    GetViolationTypesLoading: !!loading,
  };
};
